import React, { useState, useEffect, useCallback } from 'react';
import api from '../../api/client';
import DeviceStatusTable from '../../components/DeviceStatusTable';

const EMPTY = { customer_id:'', device_key:'', name:'', location:'', description:'' };

export default function AdminDevices() {
  const [devices,   setDevices]   = useState([]);
  const [customers, setCustomers] = useState([]);
  const [total,     setTotal]     = useState(0);
  const [loading,   setLoading]   = useState(true);
  const [modal,     setModal]     = useState(null);
  const [form,      setForm]      = useState(EMPTY);
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [filterCid, setFilterCid] = useState('');
  const [page,      setPage]      = useState(1);
  const [view,      setView]      = useState('table'); // 'table' | 'status'
  const [copiedKey,  setCopiedKey]  = useState(null);   // kopyalanan cihaz id'si

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit:25 };
      if (filterCid) params.customer_id = filterCid;
      const { data } = await api.get('/devices', { params });
      setDevices(data.data);
      setTotal(data.pagination.total);
    } finally { setLoading(false); }
  }, [filterCid, page]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    api.get('/customers', { params:{limit:200} }).then(r=>setCustomers(r.data.data||[])).catch(()=>{});
  }, []);

  const openCreate = () => { setForm(EMPTY); setEditId(null); setModal('form'); };
  const openEdit   = d => { setForm({ customer_id:d.customer_id, device_key:d.device_key, name:d.name, location:d.location||'', description:d.description||'' }); setEditId(d.id); setModal('form'); };
  const close      = () => setModal(null);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editId) await api.put(`/devices/${editId}`, form);
      else        await api.post('/devices', form);
      close(); load();
    } catch (err) { alert(err.response?.data?.message || 'Hata'); }
    finally { setSaving(false); }
  };

  const handleRegenKey = async (device) => {
    if (!window.confirm(`${device.name} için API key yenilenecek. Devam?`)) return;
    try {
      const { data } = await api.post(`/devices/${device.id}/regenerate-key`);
      alert(`Yeni API Key:\n${data.data.api_key}`);
      load();
    } catch (e) { alert('Hata: ' + (e.response?.data?.message || e.message)); }
  };

  const deactivate = async d => {
    if (!window.confirm(`${d.name} cihazı devre dışı bırakılsın mı?`)) return;
    await api.delete(`/devices/${d.id}`);
    load();
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
        <div className="page-header" style={{ margin:0 }}>
          <h1>Cihazlar</h1>
          <p>{total} cihaz kayıtlı</p>
        </div>
        <button className="btn btn-primary" onClick={openCreate}>+ Cihaz Ekle</button>
      </div>

      {/* Filtre + View seçimi */}
      <div style={{ display:'flex', gap:12, marginBottom:16, flexWrap:'wrap', alignItems:'center' }}>
        <select value={filterCid} onChange={e=>{setFilterCid(e.target.value);setPage(1);}} style={{ width:220 }}>
          <option value="">Tüm Müşteriler</option>
          {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <div style={{ display:'flex', gap:4, background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', padding:3 }}>
          <button onClick={()=>setView('table')}  style={{ padding:'5px 14px', borderRadius:5, border:'none', background:view==='table'?'var(--accent)':'transparent', color:view==='table'?'#fff':'var(--text2)', cursor:'pointer', fontSize:13 }}>Tablo</button>
          <button onClick={()=>setView('status')} style={{ padding:'5px 14px', borderRadius:5, border:'none', background:view==='status'?'var(--accent)':'transparent', color:view==='status'?'#fff':'var(--text2)', cursor:'pointer', fontSize:13 }}>Durum</button>
        </div>
        <button className="btn btn-secondary btn-sm" onClick={load}>↻ Yenile</button>
      </div>

      {/* Durum kartları */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(140px, 1fr))', gap:10, marginBottom:16 }}>
        {[
          { label:'Toplam',     val:total,                                    color:'var(--accent)' },
          { label:'Çevrimiçi',  val:devices.filter(d=>d.status==='online').length,  color:'var(--green)' },
          { label:'Çevrimdışı', val:devices.filter(d=>d.status==='offline').length, color:'var(--red)' },
          { label:'Alarm',      val:devices.reduce((s,d)=>s+Number(d.active_alarms||0),0), color:'var(--yellow)' },
        ].map(s=>(
          <div key={s.label} className="card" style={{ padding:'12px 14px', borderTop:`3px solid ${s.color}` }}>
            <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.08em', color:'var(--text3)', marginBottom:4 }}>{s.label}</div>
            <div style={{ fontSize:22, fontFamily:'var(--font-display)', fontWeight:800, color:s.color }}>{s.val}</div>
          </div>
        ))}
      </div>

      {view === 'status' ? (
        <div className="card">
          <DeviceStatusTable devices={devices} loading={loading} showCustomer onRegenerateKey={handleRegenKey} />
        </div>
      ) : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Cihaz</th><th>Müşteri</th><th>Durum</th><th>Bugün</th><th>API Key</th><th>Son HB</th><th>Son Veri</th><th>Alarm</th><th>İşlem</th></tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={9} style={{ textAlign:'center', padding:32, color:'var(--text3)' }}><span className="spinner" /></td></tr>
                ) : devices.length === 0 ? (
                  <tr><td colSpan={9} style={{ textAlign:'center', padding:32, color:'var(--text3)' }}>Cihaz bulunamadı</td></tr>
                ) : devices.map(d => {
                  const hbAgo = d.last_heartbeat ? Math.round((Date.now()-new Date(d.last_heartbeat).getTime())/60000) : null;
                  const evAgo = d.last_event_today ? Math.round((Date.now()-new Date(d.last_event_today).getTime())/60000) : null;
                  return (
                    <tr key={d.id}>
                      <td>
                        <div style={{ fontWeight:600 }}>{d.name}</div>
                        <div style={{ fontSize:10, color:'var(--text3)', fontFamily:'monospace' }}>{d.device_key}</div>
                      </td>
                      <td style={{ color:'var(--text2)', fontSize:12 }}>{d.customer_name}</td>
                      <td>
                        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                          <span style={{ width:8, height:8, borderRadius:'50%', background:d.status==='online'?'var(--green)':'var(--text3)', display:'block', boxShadow:d.status==='online'?'0 0 6px var(--green)':'none' }} />
                          <span style={{ fontSize:12, color:d.status==='online'?'var(--green)':'var(--text3)' }}>
                            {d.status==='online'?'Online':'Offline'}
                          </span>
                        </div>
                      </td>
                      <td><strong>{Number(d.today_in||0).toLocaleString('tr-TR')}</strong></td>
                      <td style={{ maxWidth:200 }}>
                        {d.api_key ? (
                          <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                            <code style={{ fontSize:9.5, background:'var(--bg3)', padding:'2px 5px', borderRadius:4, color:'var(--text2)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:120, display:'inline-block', verticalAlign:'middle' }}>
                              {d.api_key}
                            </code>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(d.api_key).then(() => {
                                  setCopiedKey(d.id);
                                  setTimeout(() => setCopiedKey(c => c === d.id ? null : c), 2000);
                                });
                              }}
                              style={{ padding:'2px 7px', fontSize:10, borderRadius:4, border:'1px solid var(--border)', background: copiedKey===d.id ? 'var(--green)' : 'var(--surface)', color: copiedKey===d.id ? '#fff' : 'var(--text2)', cursor:'pointer', whiteSpace:'nowrap', flexShrink:0, transition:'background 0.15s,color 0.15s' }}
                            >
                              {copiedKey === d.id ? '✓' : 'Kopyala'}
                            </button>
                          </div>
                        ) : <span style={{ color:'var(--text3)', fontSize:11 }}>—</span>}
                      </td>
                      <td style={{ fontSize:11, color:hbAgo!==null&&hbAgo<2?'var(--green)':hbAgo<10?'var(--yellow)':'var(--text3)' }}>
                        {hbAgo!==null ? `${hbAgo} dk` : '—'}
                      </td>
                      <td style={{ fontSize:11, color:evAgo!==null&&evAgo<5?'var(--green)':evAgo<15?'var(--yellow)':'var(--text3)' }}>
                        {evAgo!==null ? `${evAgo} dk` : '—'}
                      </td>
                      <td>
                        {Number(d.active_alarms||0) > 0
                          ? <span style={{ background:'var(--red-dim)', color:'var(--red)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:12, padding:'2px 8px', fontSize:11, fontWeight:700 }}>{d.active_alarms}</span>
                          : <span style={{ color:'var(--text3)', fontSize:11 }}>—</span>}
                      </td>
                      <td>
                        <div style={{ display:'flex', gap:5 }}>
                          <button className="btn btn-secondary btn-sm" onClick={()=>openEdit(d)}>Düzenle</button>
                          <button className="btn btn-secondary btn-sm" onClick={()=>handleRegenKey(d)} title="API Key Yenile">🔑</button>
                          <button className="btn btn-danger btn-sm" onClick={()=>deactivate(d)}>Sil</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {total > 25 && (
            <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:14 }}>
              <button className="btn btn-secondary btn-sm" disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Önceki</button>
              <span style={{ lineHeight:'30px', fontSize:13, color:'var(--text2)' }}>Sayfa {page} / {Math.ceil(total/25)}</span>
              <button className="btn btn-secondary btn-sm" disabled={page*25>=total} onClick={()=>setPage(p=>p+1)}>Sonraki →</button>
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {modal === 'form' && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&close()}>
          <div className="modal admin-form-modal">
            <div className="modal-header">
              <h3>{editId ? 'Cihaz Düzenle' : 'Yeni Cihaz'}</h3>
              <button className="btn btn-secondary btn-icon" onClick={close}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Müşteri *</label>
                <select value={form.customer_id} onChange={e=>setForm(f=>({...f,customer_id:e.target.value}))} required>
                  <option value="">Seçin...</option>
                  {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Cihaz Key *</label>
                  <input value={form.device_key} onChange={e=>setForm(f=>({...f,device_key:e.target.value}))} placeholder="PROMA-GIRIS-001" required disabled={!!editId} />
                </div>
                <div className="form-group">
                  <label>Cihaz Adı *</label>
                  <input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} required />
                </div>
              </div>
              <div className="form-group">
                <label>Konum</label>
                <input value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} placeholder="A Girişi" />
              </div>
              <div className="form-group">
                <label>Açıklama</label>
                <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={2} style={{ resize:'vertical' }} />
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:8 }}>
                <button type="button" className="btn btn-secondary" onClick={close}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving?'Kaydediliyor...':'Kaydet'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
